import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import InterviewSessions from "./pages/InterviewSessions";
import SessionDetails from "./pages/SessionDetails";
import IntervieweeLanding from "./pages/IntervieweeLanding";
import IntervieweeChat from "./pages/IntervieweeChat";
import Navbar from "./components/Navbar";

export default function App() {
  return (
    <div className="app">
      <Navbar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard/:userId" element={<Dashboard />} />
          <Route path="/interviews/:interviewId/sessions" element={<InterviewSessions />} />
          <Route path="/sessions/:sessionId" element={<SessionDetails />} />
          <Route path="/interviewee/:linkId" element={<IntervieweeLanding />} />
          <Route path="/interviewee/chat/:sessionId" element={<IntervieweeChat />} />
        </Routes>
      </main>
    </div>
  );
}
